import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import {
  AthletePackageAllLimitedCreditsUsed,
  AthletePackageAllLimitedCreditsUsedRequest,
  ErrorMessage,
} from 'types';
import { client } from 'utils/api-client';

export default function useAthletePackageAllLimitedCreditsUsed(): UseMutationResult<
  AxiosResponse<AthletePackageAllLimitedCreditsUsed>,
  AxiosError<ErrorMessage>,
  AthletePackageAllLimitedCreditsUsedRequest
> {
  const queryFn = (
    payload: AthletePackageAllLimitedCreditsUsedRequest,
  ): Promise<AxiosResponse<AthletePackageAllLimitedCreditsUsed>> => {
    return client.post(`athlete-packages/all-limited-credits-used/`, payload);
  };

  return useMutation(queryFn);
}
